module.exports = __webpack_public_path__ + "media/images/lp/industries/feature-03-c6b4f4f5e165b25ba60d8060ed7df95d.png";